import { takeLatest, put } from 'redux-saga/effects'
import NProgress from 'nprogress'

import { apiClient } from 'Module/API/Client'

import * as CONST from 'Reducers/Document/const'
import * as ERRORS from 'Reducers/Errors/const'
import { callApi } from 'Reducers/apiCall'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'

/**
 * Get document types
 *
 * @param action
 */
function* getDocumentTypes(action) {
  NProgress.start()
  const response = yield callApi(apiClient.getDocumentTypes)
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      yield put({
        type: CONST.GET_DOCUMENT_TYPES_SUCCESS,
        payload: {
          documentTypesList: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}
  NProgress.done()
}

/**
 * Get document type by id
 *
 * @param action
 */
function* getDocumentTypeById(action) {
  NProgress.start()
  yield put(incUIBlockCounter())

  const response = yield callApi(apiClient.getDocumentTypeById, action.id)
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      yield put({
        type: CONST.GET_DOCUMENT_TYPE_BY_ID_SUCCESS,
        payload: {
          documentTypeById: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Update document type by id
 *
 * @param action
 */
function* updateDocumentTypeById(action) {
  const { callbacks, id, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  const response = yield callApi(apiClient.updateDocumentTypeById, id, payload)
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Create document type
 *
 * @param action
 */
function* createDocumentType(action) {
  const { callbacks, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  const response = yield callApi(apiClient.createDocumentType, payload)
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Delete document type
 */
function* deleteDocumentTypeById() {
  NProgress.start()

  try {
    yield put({
      type: CONST.DELETE_DOCUMENT_TYPE_BY_ID_SUCCESS,
      payload: {
        documentTypeById: {},
      },
    })
  } catch (ex) {}
  NProgress.done()
}

/**
 * Get document types watcher
 */
export function* watchGetDocumentTypes() {
  yield takeLatest(CONST.GET_DOCUMENT_TYPES, getDocumentTypes)
}

/**
 * Get document type by id watcher
 */
export function* watchGetDocumentTypeById() {
  yield takeLatest(CONST.GET_DOCUMENT_TYPE_BY_ID, getDocumentTypeById)
}

/**
 * Update document type by id watcher
 */
export function* watchUpdateDocumentTypeById() {
  yield takeLatest(CONST.UPDATE_DOCUMENT_TYPE_BY_ID, updateDocumentTypeById)
}

/**
 * Create document type watcher
 */
export function* watchCreateDocumentType() {
  yield takeLatest(CONST.CREATE_DOCUMENT_TYPE, createDocumentType)
}

/**
 * Delete document type by id watcher
 */
export function* watchDeleteDocumentTypeById() {
  yield takeLatest(CONST.DELETE_DOCUMENT_TYPE_BY_ID, deleteDocumentTypeById)
}



// WEBPACK FOOTER //
// ./src/Reducers/Document/sagas.js